import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import VideoPlayerDispenserHelper from "./VideoPlayerDispenserHelper";

export default class InitVideoPlayerTask extends Task {
    async execute(callback, progressCallback) {
        // initialize videos dispenser as it needs to be initialized as soon as possible
        // (specially before videos are preloaded)
        try {
            await VideoPlayerDispenserHelper.initialize();
        } catch (err) {
            console.error(err);
        } finally {
            //Task complete:
            callback(this);
        }
    }
}